export default __webpack_public_path__ + "static/media/Cassette.ed308e7b.gif";